export function validateBid(bid) {
  const isDecimal = parseInt(bid) === Number(bid);
  const isNonNegative = parseInt(bid) >= 0;

  const bidStr = bid.toString();
  const isNotEmpty = bidStr.length > 0;
  // This is a locale agnostic way to address cases like "2." which shouldn't pass validation
  const isEndingWithDigit = isNotEmpty && !isNaN(parseInt(bidStr.slice(-1)));

  return {
    isDecimal,
    isNotEmpty,
    isNonNegative,
    isEndingWithDigit,
  };
}
